import React from "react";
import styled from "styled-components";
// Assets
import LogoImg from "../assets/logo_OSSUR_app.png";

const LogoMainDiv = styled.div`
  width: 100%;
  position: absolute;
  @media (max-width: 1290px) {
    display: none;
  }
`;
const LogoDiv = styled.div`
  margin: 0 auto;
  width: 100%;
  max-width: 860px;
`;
const Logo = styled.img`
  position: relative;
  top: -10px;
  left: -170px;
`;

const StickyLogo = () => (
  <LogoMainDiv>
    <LogoDiv>
      <Logo src={LogoImg} alt="logo" />
    </LogoDiv>
  </LogoMainDiv>
);

export default StickyLogo;
